import { Toast } from 'vant'
class ContinuousClickCall {
  constructor() {
    this.caned = {}
  }
  async call({ fn, key }) {
    if (!this.caned[key] && fn) {
      this.caned[key] = true
      await fn()
      this.caned[key] = false
    } else {
      Toast('不可重复点击')
    }
  }
}
export default ContinuousClickCall
